module.exports = __webpack_public_path__ + "img/safari.b6d7facf.svg";